<template>
  <section class="space-y-4">
    <template v-if="members.length > 0">
      <member
        v-for="(member, idx) in members"
        :key="idx"
        :member="member"
      />
    </template>
    <div v-else>No Members</div>
  </section>
</template>

<script>
import Member from './member/member.vue';

export default {
  name: 'members',
  components: {
    Member,
  },
  props: {
    members: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>
